import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";
import {isNullOrUndefined} from '@abydos-angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class AtmosphereService {

    private requestUrls: string[] = [];
    private atmosphere: any = {};
    private isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) {
            import('atmosphere.js').then(mod => {
                this.atmosphere = mod;
            });
        }
    }

    public async subscribe(url: string, onMessageCallBack: (response: any) => void, onOpenCallBack?: () => void): Promise<void> {
        if (!this.isBrowser) {
            return;
        }
        if (!this.atmosphere) {
            this.atmosphere = await import('atmosphere.js');
        }
        if (isNullOrUndefined(onMessageCallBack) || isNullOrUndefined(url)) {
            throw new Error('Provide an onMessageCallBack and URL to use AtmosphereConnectorService!');
        }
        const request: Atmosphere.Request = {
            url: url,
            transport: 'websocket',
            headers: {'X-Atmosphere-WebSocket-Proxy': 'true'},
            fallbackTransport: 'long-polling',
            contentType: 'application/json; charset=UTF-8',
            logLevel: 'debug',
            maxReconnectOnClose: 180,
            reconnectInterval: 5000,
            onMessage: onMessageCallBack,
            enableProtocol: false,
            onOpen: (param) => {
                console.log(`WebSocket connection successfully established with ${url}`);
                this.requestUrls.push(url);
                if (isNotNullOrUndefined(onOpenCallBack)) {
                    onOpenCallBack!();
                }
            },
            onReconnect: () => {
                console.log(`WebSocket connection lost, trying to reconnect to ${url}`);
                request.transport = 'websocket';
            },
            onReopen: () => {
                console.log(`WebSocket connection successfully reopened with ${url}`);
                if (isNotNullOrUndefined(onOpenCallBack)) {
                    onOpenCallBack!();
                }
            }
        };
        if (isNotNullOrUndefined(this.atmosphere.subscribe)) {
            this.atmosphere.subscribe(request);
            this.requestUrls.push(url);
        }
    }

    /**
     * Leiratkozunk az ezen AtmosphereService példány általi összes feliratkozásról
     */
    public unsubscribe(): void {
        if (!this.isBrowser || !this.atmosphere) {
            return;
        }

        this.requestUrls.forEach(value => {
            this.atmosphere.unsubscribeUrl(value);
        });
        this.requestUrls = [];
    }

    public unsubscribeFromUrl(url: string): void {
        if (!this.isBrowser || !this.atmosphere) return;

        const subscribedUrl = this.requestUrls.find(value => value === url);
        if (isNotNullOrUndefined(subscribedUrl)) {
            this.atmosphere.unsubscribeUrl(subscribedUrl);
            this.requestUrls = this.requestUrls.filter(value => value !== url);
        }
    }
}
